module.exports = __webpack_public_path__ + "static/img/pic_word_big@2x.3dde1f20.png";